import React from 'react';

import Code from '@atlaskit/code/code';
import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { Table, TBody, TD, TH, THead, TR } from '@atlaskit/table/primitives';
import { token } from '@atlaskit/tokens';

import HorizontalScrollContainer from '../../horizontal-scroll-container';

const styles = cssMap({
	container: {
		paddingBlockEnd: token('space.200'),
	},
});

export type MotionTokenTableValue = {
	tokenName: string;
	component?: string;
	useFor?: string;
	value?: string;
};

interface BaseMotionTokenTableProps {
	values: MotionTokenTableValue[];
	testId?: string;
}

/**
 * __Base motion token table__
 */
export const BaseMotionTokenTable = ({
	values,
	testId,
}: BaseMotionTokenTableProps): React.JSX.Element => {
	const hideValue = values.every((value) => value.value === undefined);
	const hideComponent = values.every((value) => value.component === undefined);
	const hideUseFor = values.every((value) => value.useFor === undefined);

	return (
		<HorizontalScrollContainer>
			<Box xcss={styles.container}>
				<Table testId={testId}>
					<THead>
						<TR isBodyRow={false}>
							<TH width="300px">Token</TH>
							{!hideValue && <TH width="100px">Value</TH>}
							{!hideUseFor && <TH width="400px">Use for</TH>}
							{!hideComponent && <TH width="400px">Component</TH>}
						</TR>
					</THead>
					<TBody>
						{values.map((token) => {
							return (
								<TR key={token.tokenName}>
									<TD>
										<Code>{token.tokenName}</Code>
									</TD>
									{!hideValue && (
										<TD>
											<Text>{token.value}</Text>
										</TD>
									)}
									{!hideUseFor && (
										<TD>
											<Text>{token.useFor}</Text>
										</TD>
									)}
									{!hideComponent && (
										<TD>
											<Text>{token.component}</Text>
										</TD>
									)}
								</TR>
							);
						})}
					</TBody>
				</Table>
			</Box>
		</HorizontalScrollContainer>
	);
};
